module.exports = __webpack_public_path__ + "static/media/StarPlayLogo-1.c40fdf4d.png";